import React from 'react';
import { Baby, Leaf } from 'lucide-react';
import { pregnancyPlans } from '../data/pregnancyPlans';
import type { Goal, PregnancyStage } from '../types/platform';
type StatusMarkerProps = {
  goal: Goal;
  stage?: PregnancyStage;
  size?: 'sm' | 'md';
};
export function StatusMarker({
  goal,
  stage,
  size = 'md'
}: StatusMarkerProps) {
  const isPregnant = goal === 'pregnancy';
  const stageName = pregnancyPlans.find(p => p.id === stage)?.name;
  const Icon = isPregnant ? Baby : Leaf;
  return <span className={`inline-flex items-center gap-1.5 rounded-full border font-medium ${isPregnant ? 'border-[#9b8cf0]/50 bg-[#9b8cf0]/15 text-[#c4baff]' : 'border-[#8fd3b0]/40 bg-[#8fd3b0]/10 text-[#8fd3b0]'} ${size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-3 py-1 text-xs'}`} data-id="element-123" data-mp="3ed49j49bwupt">
      <Icon className={size === 'sm' ? 'size-3' : 'size-3.5'} data-id="element-124" data-mp="17lv4ir1sbfjh" />
      {isPregnant ? 'Pregnant' : 'Wellbeing'}
      {isPregnant && stageName && size === 'md' && <span className="opacity-70" data-id="element-125" data-mp="20n2l65p0oph2">· {stageName}</span>}
    </span>;
}